import React from "react";
import "./whyChooseUs.css";

import trustImg from "../assets/trust 1 - Copy.png";
import quickDeliveryImg from "../assets/quick-delivery 1.png";
import qualityBadgeImg from "../assets/quality-badge (1) 1.png";
import customerExperienceImg from "../assets/customer-experience 1.png";

const WhyChooseUs = () => {
  const cards = [
    {
      id: 1,
      img: trustImg,
      title: "20+ years of industry experience",
      text:
        "Unlike other companies, we are a UX first development company. Projects are driven by designers and they make sure design and experiences translate to code.",
      iconBgClass: "icon-bg-trust"
    },
    {
      id: 2,
      img: qualityBadgeImg,
      title: "Trusted supplier to Zilla, Taluk & Grama Panchayats",
      text:
        "Unlike other companies, we are a UX first development company. Projects are driven by designers and they make sure design and experiences translate to code.",
      iconBgClass: "icon-bg-quality"
    },
    {
      id: 3,
      img: quickDeliveryImg,
      title: "High-quality registers and office stationery",
      text:
        "Unlike other companies, we are a UX first development company. Projects are driven by designers and they make sure design and experiences translate to code.",
      iconBgClass: "icon-bg-highquality"
    },
    {
      id: 4,
      img: customerExperienceImg,
      title: "Reliable and timely delivery",
      text:
        "Unlike other companies, we are a UX first development company. Projects are driven by designers and they make sure design and experiences translate to code.",
      iconBgClass: "icon-bg-reliable"
    }
  ];

  return (
    <section className="why-section">
      <div className="why-inner">
        <h2 className="why-title">
          Why <span>Choose Us</span>
        </h2>

        <div className="why-grid">
          {cards.map((card) => (
            <div key={card.id} className="why-card">
              <div className={`why-icon-wrapper ${card.iconBgClass}`}>
                <img src={card.img} alt={card.title} className="why-icon" />
              </div>
              <div className="why-content">
                <h3 className="why-card-title">{card.title}</h3>
                <p className="why-card-text">{card.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;